import React from 'react';
import ServiceTemplate from './ServiceTemplate';

const TrademarkMonitoring = () => {
  const usps = [
    {
      title: 'Real-Time Monitoring Alerts',
      description: 'Get instant notifications whenever a new application resembles your mark. Our systems scan USPTO filings around the clock so nothing slips past your brand\'s defense.'
    },
    {
      title: 'Weekly Watch Reports',
      description: 'Clear, attorney-reviewed summaries delivered on schedule. Know which applications are genuinely risky and which are harmless, without sorting raw legal data yourself.'
    },
    {
      title: 'Marketplace & Domain Watch',
      description: 'Protection extends beyond the trademark office. We track ecommerce listings and domain registrations for unauthorized uses of your name, logo, and slogans.'
    },
    {
      title: 'Rapid Response Playbook',
      description: 'When a conflict surfaces, we move fast. From cease-and-desist letters to opposition filings, our team lays out your options and recommended next steps right away.'
    }
  ];

  const whyChooseContent = {
    about: 'Registering a trademark is only the beginning. Without continuous monitoring, copycats and confusingly similar marks can erode your exclusive rights. Trademark monitoring keeps you informed about new filings and unauthorized uses so you can act before damage is done.',
    intro: 'Trademark Vector\'s monitoring service works as a 24/7 guardian for your brand, watching federal filings, marketplaces, and domains so your rights stay enforceable.',
    paragraph1: 'Our platform combines automated screening technology with human legal review. Every potential conflict is vetted by specialists, filtered for genuine risk, and reported to you in plain language with a recommended course of action.',
    paragraph2: 'Whether you own one trademark or a growing portfolio, our monitoring scales with your business. Customizable watch parameters, prompt alerts, and attorney-backed guidance ensure you never miss a threat—or a critical deadline to respond.'
  };

  return (
    <ServiceTemplate
      title="Trademark Monitoring"
      subtitle="Protect Your Brand with Round-the-Clock Trademark Watch Services"
      description="Stop infringers before they become a problem. Our trademark monitoring service tracks new USPTO filings, marketplaces, and domains, alerting you the moment a confusingly similar mark appears."
      heroImage="https://images.unsplash.com/photo-1551288049-bebda4e38f71"
      aboutImage="https://images.unsplash.com/photo-1563986768609-322da13575f3?w=800"
      serviceId="trademark-monitoring"
      metaTitle="Trademark Monitoring & Brand Watch Services | Trademark Vector"
      metaDescription="24/7 monitoring of USPTO filings, marketplaces & domains. Instant alerts on copycats, weekly attorney-reviewed reports & rapid response to threats."
      usps={usps}
      whyChooseContent={whyChooseContent}
    />
  );
};

export default TrademarkMonitoring;
